import type { EntityDetailSchema } from '@web-config-app/core';
import {
  mockCactusEntity,
  mockSimpleSchema,
  mockEntityDetail,
  mockConfigEntitySchemaWithDomainEntityAttributes,
  mockEntityMeta,
} from '@web-config-app/mock-data';
import type { EntityDetailsProviderProps } from '../components';
import { mockOperations } from './mock-operations';

export const getEntityDetailsProviderMockProps = ({
  data,
  rootSchema,
  path,
  instanceId,
  useDefaultData = true,
  isUsingConfigAppBackend,
}: {
  data?: any;
  rootSchema?: EntityDetailSchema;
  path?: string;
  instanceId?: string;
  useDefaultData?: boolean;
  isUsingConfigAppBackend?: boolean;
} = {}): EntityDetailsProviderProps => {
  const fallbackData = useDefaultData ? mockEntityDetail : undefined;
  return {
    configEntitySchema:
      mockConfigEntitySchemaWithDomainEntityAttributes as EntityDetailSchema,
    domainEntity: mockCactusEntity,
    rootSchema: rootSchema ?? mockSimpleSchema,
    entityRootData: data ?? fallbackData,
    currentAuthoringEnvironment: 'staging',
    path: path ?? '',
    entityType: mockCactusEntity.type,
    entityMeta: mockEntityMeta,
    setEntityData: () => () => {},
    onTreeNodeSelect: () => {},
    operations:
      mockOperations as unknown as EntityDetailsProviderProps['operations'],
    includedEntities: [],
    setIncludedEntities: () => () => {},
    addIncludedEntity: () => () => {},
    resetEntityData: () => {},
    name: mockEntityDetail.attributes.entityMetadata.name,
    status: mockEntityDetail.attributes.entityMetadata.status,
    instanceId,
    isUsingConfigAppBackend,
  };
};
